import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.3335 7.99935L6.44095 11.3327L12.6668 4.66602",
  stroke: "#22C55E",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")!

  return (_openBlock(), _createBlock(_component_SvgWrapper, {
    class: "check-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}